/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';

const ContextModal = React.createContext();

export const useModalContext = () => React.useContext(ContextModal);

export default ContextModal;
